import React from 'react';
import wbenc from '@/assets/partners/wbenc-collegiate-accelerator.png';
import famtech from '@/assets/partners/famtech.png';
import google from '@/assets/partners/google-for-startups.png';
import nba from '@/assets/partners/nba-all-star-2026.png';
import healla from '@/assets/partners/heal-la.png';
import cafe from '@/assets/partners/cafe.png';

const partners = [
  { name: 'Google for Startups', src: google },
  { name: 'WBENC Collegiate Accelerator', src: wbenc },
  { name: 'famtech.org', src: famtech },
  { name: 'NBA All-Star 2026 Los Angeles', src: nba },
  { name: 'Heal.LA Initiative', src: healla },
  { name: 'Center for Accelerating Financial Equity (CAFE)', src: cafe },
];

const MarqueeTrack = ({ className = '' }: { className?: string }) => (
  <div className={`flex shrink-0 items-center justify-around gap-16 md:gap-24 ${className}`}>
    {partners.map((p) => (
      <div
        key={p.name}
        className="flex shrink-0 items-center justify-center px-2"
        style={{ minWidth: '200px' }}
      >
        <img
          src={p.src}
          alt={`${p.name} logo`}
          loading="lazy"
          className="h-16 w-auto max-w-[220px] object-contain opacity-100 transition-transform duration-300 hover:scale-[1.04] md:h-20"
        />
      </div>
    ))}
  </div>
);

const Affiliations = () => (
  <section
    id="affiliations"
    aria-labelledby="affiliations-heading"
    className="border-y border-slate-200/70 bg-white overflow-hidden"
  >
    <div className="mx-auto max-w-7xl px-4 pt-10 pb-6">
      <h2
        id="affiliations-heading"
        className="text-center text-sm font-semibold uppercase tracking-widest text-slate-700"
      >
        Partners, programs &amp; recognition
      </h2>
    </div>

    <div className="group relative flex w-full overflow-hidden py-8">
      {/* Soft edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-20 bg-gradient-to-r from-white to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-20 bg-gradient-to-l from-white to-transparent" />

      <div className="logo-marquee flex items-center">
        <MarqueeTrack />
        <MarqueeTrack aria-hidden="true" />
      </div>
    </div>

    <p className="mx-auto max-w-7xl px-4 pb-10 text-center text-xs text-slate-500">
      Affiliations reflect program participation, partnerships, and community collaborations. They do not imply endorsement of tax outcomes.
    </p>
  </section>
);

export default Affiliations;
